import React from 'react';

export const SparkleIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="sparkle-icon"
      style={{ width: '18.667px', height: '18.667px' }}
    >
      <g clipPath="url(#clip0_398_1621)">
        <path
          d="M8.46749 18.7487C8.39177 18.9506 8.10628 18.9506 8.03056 18.7487L6.37658 14.34C6.35291 14.2769 6.30314 14.2272 6.24007 14.2035L1.83135 12.5495C1.62952 12.4738 1.62952 12.1883 1.83135 12.1126L6.24007 10.4586C6.30314 10.4349 6.35291 10.3852 6.37658 10.3221L8.03056 5.91338C8.10628 5.71155 8.39177 5.71155 8.46749 5.91338L10.1215 10.3221C10.1451 10.3852 10.1949 10.4349 10.258 10.4586L14.6667 12.1126C14.8685 12.1883 14.8685 12.4738 14.6667 12.5495L10.258 14.2035C10.1949 14.2272 10.1451 14.2769 10.1215 14.34L8.46749 18.7487Z"
          fill="url(#paint0_linear_398_1621)"
        />
        <path
          d="M4.09446 6.48221C4.01975 6.68644 3.73091 6.68644 3.65619 6.48221L3.05322 4.83395C3.02962 4.76943 2.97878 4.71859 2.91426 4.69499L1.266 4.09202C1.06177 4.01731 1.06177 3.72847 1.266 3.65375L2.91426 3.05078C2.97878 3.02718 3.02962 2.97634 3.05322 2.91182L3.65619 1.26356C3.73091 1.05933 4.01975 1.05933 4.09446 1.26356L4.69743 2.91182C4.72103 2.97634 4.77187 3.02718 4.83639 3.05078L6.48465 3.65375C6.68888 3.72847 6.68888 4.01731 6.48465 4.09202L4.83639 4.69499C4.77187 4.71859 4.72103 4.76943 4.69743 4.83395L4.09446 6.48221Z"
          fill="url(#paint1_linear_398_1621)"
        />
        <path
          d="M15.4662 9.43146C15.3895 9.6309 15.1073 9.6309 15.0306 9.43146L14.1514 7.1454C14.1277 7.08378 14.079 7.03508 14.0174 7.01138L11.7313 6.13217C11.5319 6.05547 11.5319 5.77331 11.7313 5.69661L14.0174 4.8174C14.079 4.7937 14.1277 4.745 14.1514 4.68337L15.0306 2.39732C15.1073 2.19788 15.3895 2.19788 15.4662 2.39732L16.3454 4.68337C16.3691 4.745 16.4178 4.7937 16.4794 4.8174L18.7654 5.69661C18.9649 5.77331 18.9649 6.05547 18.7654 6.13217L16.4794 7.01138C16.4178 7.03508 16.3691 7.08378 16.3454 7.14541L15.4662 9.43146Z"
          fill="url(#paint2_linear_398_1621)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_398_1621"
          x1="8.24902"
          y1="5.33105"
          x2="8.24902"
          y2="19.3311"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#344AFF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_398_1621"
          x1="3.87533"
          y1="0.664551"
          x2="3.87533"
          y2="7.08122"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#344AFF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_398_1621"
          x1="15.2484"
          y1="1.83105"
          x2="15.2484"
          y2="9.99772"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#344AFF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <clipPath id="clip0_398_1621">
          <rect
            width="18.6667"
            height="18.6667"
            fill="white"
            transform="translate(0.666504 0.666504)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SparkleIcon; 